// extracted by mini-css-extract-plugin
module.exports = {"form":"InventoryStock_form__20ppK","pagination":"InventoryStock_pagination__2ShP1","puttable":"InventoryStock_puttable__3jjUU"};